
  import './inputSelect';
  window.filters = new (function () {
    this.init = function(){
          window.inputSelect.initSmallSelector()

    }
    this.ajax = function(){
      
      /*$('body').on('click','[data-page]',function(e){
          e.preventDefault();
          e.stopPropagation();
          let page = $(this).attr('data-page');
          $('[data-barba-namespace]:last-child').find('[data-ajax-filter] input[name="page"]').val(page);
          let url = $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').attr('action');
          let data =  $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').serialize();
          window.filters.inject(url +'?'+ data)
  
  
      })*/
     
      $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').on('change',()=>{
        $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').addClass('loading');
          let data = $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').serialize()
          let url = $('[data-barba-namespace]:last-child').find('[data-ajax-filter]').attr('action');
          $('[data-barba-namespace]:last-child').find('[data-ajax-filter] input[name="page"]').val('1');
  
          this.inject(url +'?'+ data)
      })
      
      
     
    }
         
    this.inject = function(url){
        //window.history.replaceState('', '', url);
        $('body').addClass('is-loading')
        window.barbaInstance.history.add(url, 'barba');
        $.ajax({
              url: url,
              type: 'GET',
              success: function(content) {
                  console.log('contet',content)
                  $('[data-barba-namespace]:last-child').find('[data-ajax-content]').replaceWith($(content).find('[data-ajax-content]'));
                  window.filters.init()
                  window.filters.ajax()

                  window.imageLoader.lazy($('[data-barba-namespace]:last-child').find('[data-ajax-content]')).then(function(res) {
                     

    
                  });
                  $('body').removeClass('is-loading')

                  window.scrollAnimation.update()
  
  
                  //window.scrollAnimation.update();
                  appEvent.trigger('app:ajaxInjected')
  
                  
  
  
              }
          });
  
    }
  
  
   
  })
  